import { render, staticRenderFns } from "./ViewUploadErrorsModal.vue?vue&type=template&id=c61d8a08&scoped=true&"
import script from "./ViewUploadErrorsModal.vue?vue&type=script&lang=js&"
export * from "./ViewUploadErrorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61d8a08",
  null
  
)

export default component.exports